module.exports = __webpack_public_path__ + "c49b88a58463151eb5714b2d9d274440.svg";